import { createBrowserHistory } from 'history';
var history = createBrowserHistory();
export default history;
